import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CustomerResponse } from '@/api/services/billing/common-customer/billing-common-customer.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import { PaymentMethodResponse } from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'
import { EnumResponse } from '@/api/services/common.dto'
import { InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'

export enum InvoiceReceiptStatus {
    GENERATED = 'GENERATED',
    VERIFIED = 'VERIFIED'
}
export interface InvoiceReceiptStatusEnumResponse extends EnumResponse {
    code: InvoiceReceiptStatus
}

export interface InvoiceReceiptResponse {
    id: number
    label: string
    customer: StrictNullable<CustomerResponse>
    generator: StrictNullable<CommonPersonnelResponse>
    generationDate: string
    verificationDate: StrictNullable<string>
    verifier: StrictNullable<CommonPersonnelResponse>
    externalReference: StrictNullable<string>
    paymentDate: StrictNullable<string>
    paymentMethod: StrictNullable<PaymentMethodResponse>
    conceptsRealTotalValue: StrictNullable<number>
    realTotalValue: StrictNullable<number>
    invoiceAccountingUnit: StrictNullable<AccountingUnitResponse>
    appliedBillableConceptCount: number
    billableDeliveryNoteCount: number
    status: InvoiceReceiptStatusEnumResponse
    invoice: InvoiceResponse
}

export interface InvoiceReceiptPatchRequest {
    id: number
    realTotalValue?: Nullable<number>
    externalReference?: Nullable<string>
    paymentDate?: Nullable<string>
    paymentMethodId?: Nullable<number>
}
